export interface InspectionGroup {
  name: string;
  inspectionElements: InspectionElement[];
}

export interface InspectionElement {
  name: string;
  description: string;
}

export const INSPECTION_GROUPS: InspectionGroup[] = [
  {
    name: 'Grundgerät',
    inspectionElements: [
      { name: 'Rahmen', description: '' },
      { name: 'Lagerungen', description: '' },
      { name: 'Gegengewichte', description: '' },
      { name: 'Anhängervorrichtung', description: '' },
      { name: 'Fahrwerk', description: '' },
      { name: 'Bereifung/Ketten', description: '' },
      { name: 'Transportösen', description: '' },
    ],
  },
  {
    name: 'Antrieb',
    inspectionElements: [
      { name: 'Dichtheit', description: '' },
      { name: 'Abgase', description: '' },
      { name: 'Schalldämmung Antrieb', description: '' },
    ],
  },
  {
    name: 'Arbeitseinrichtungen',
    inspectionElements: [
      { name: 'Schaufel, Schild, Anbaugeräte', description: '' },
      { name: 'Lasthaken', description: '' },
      { name: 'Greifer', description: '' },
      { name: 'Verriegelung Schnellwechsler', description: '' },
      { name: 'Transportsicherung', description: '' },
    ],
  },
  {
    name: 'Sichere Zugänge',
    inspectionElements: [
      { name: 'Haltegriffe/Stangen', description: '' },
      { name: 'Auftritte/Trittflächen', description: '' },
      { name: 'Gummimatten', description: '' },
    ],
  },
  {
    name: 'Fahrerkabine',
    inspectionElements: [
      { name: 'Tür, Fensterverriegelung', description: '' },
      { name: 'Scheibenwischer', description: '' },
      { name: 'Sitz, Sicherheitsgurte', description: '' },
      { name: 'Heizung, Lüftung', description: '' },
      { name: 'Schalldämmung', description: '' },
    ],
  },
  {
    name: 'Sicht',
    inspectionElements: [
      {
        name: 'Spiegel (außen, innen)',
        description:
          'Kamera-, Monitorsysteme Vereinfachtes Verfahren zur Überprüfung der Sichtfeldes: Kann der Fahrer eine im Abstand von 1,0 m vor bzw. hinter der Maschine gehende / stehende Personen sehen?',
      },
    ],
  },
  {
    name: 'Bedienungseinrichtungen',
    inspectionElements: [
      { name: 'Gas, Kupplung, Schaltung', description: '' },
      { name: 'Hebelarretierung', description: '' },
      { name: 'Pedale (Griffigkeit + Beweglichkeit)', description: '' },
    ],
  },
  {
    name: 'Elektrische Anlage',
    inspectionElements: [
      { name: 'Batterien', description: '' },
      { name: 'Beleuchtung', description: '' },
      { name: 'Hupe', description: '' },
      { name: 'Kontrollinstrumente', description: '' },
    ],
  },
  {
    name: 'Hydraulik-/Druckluftanlage',
    inspectionElements: [
      { name: 'Ventile', description: '' },
      { name: 'Leitungen', description: '' },
      { name: 'Schläuche', description: '' },
      { name: 'Zylinder', description: '' },
    ],
  },
  {
    name: 'Bremsanlage',
    inspectionElements: [
      { name: 'Fahrbremse', description: '' },
      { name: 'Feststellbremse', description: '' },
    ],
  },
  {
    name: 'Lenkung',
    inspectionElements: [{ name: 'Lenkung', description: '' }],
  },
  {
    name: 'Schutzeinrichtung',
    inspectionElements: [
      { name: 'Verkleidungen', description: '' },
      { name: 'Abdeckungen', description: '' },
      { name: 'Schutzdach', description: '' },
      { name: 'Zylinderarretierung', description: '' },
      { name: 'Warnanstrich', description: '' },
    ],
  },
  {
    name: 'Zubehör',
    inspectionElements: [
      { name: 'Betriebsanleitung', description: '' },
      { name: 'Warnschilder', description: '' },
      { name: 'Verbandzeug', description: '' },
      { name: 'Feuerlöscher', description: '' },
      { name: 'Unterlegkeil', description: '' },
      { name: 'Lasthaken/-sicherung', description: '' },
    ],
  },
  {
    name: 'Hebezeuge',
    inspectionElements: [
      { name: 'Ausleger', description: '' },
      { name: 'Drahtseile', description: '' },
      { name: 'Überlast (Warnschaltung)', description: '' },
      { name: 'Notendhalteeinrichtung', description: '' },
      { name: 'Drahtseile', description: '' },
    ],
  },
];
